import * as React from 'react'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ContentBack } from './ContentBack/ContentBack'
import { ContentFront } from './ContentFront/ContentFront'
import {
  flipCard,
  selectGainMoreCustomers,
} from '@user/store/dashboard/widgets/gainMoreCustomers/slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { WidgetWrapper } from '../../Widget/WidgetWrapper'

export const GainMoreCustomers: FC = () => {
  const dispatch = useAppDispatch()
  const { showFront } = useSelector(selectGainMoreCustomers)

  const handleFlipCard = useCallback(() => {
    dispatch(flipCard())
  }, [dispatch])

  return (
    <WidgetWrapper
      testIdPrefix="gain-more-customers-widget"
      contentFront={<ContentFront />}
      contentBack={<ContentBack />}
      title="Gain More Customers"
      settingsAction={handleFlipCard}
      showFront={showFront}
    />
  )
}

GainMoreCustomers.displayName = 'GainMoreCustomers'
